const { wlGlobalConfig, wlApiConfig, wlAlgolia } = window;

export const ENV = wlGlobalConfig.__environment;
export const SITE_URL = wlGlobalConfig.__site_url;
export const AJAX_URL =
  ENV === 'review'
    ? `${SITE_URL}/wp/wp-admin/admin-ajax.php?action=`
    : `${SITE_URL}/wp-admin/admin-ajax.php?action=`;

export const GOOGLE_MAPS_API_KEY = wlGlobalConfig.__google_maps_api_key;

export const ALGOLIA_APP_ID = wlAlgolia ? wlAlgolia.application_id : '';
export const ALGOLIA_SEARCH_API_KEY = wlAlgolia ? wlAlgolia.search_api_key : '';

export const environment = ENV === 'development' ? 'local' : ENV;
export const ALGOLIA_INDEX = {
  main: `burrell_${environment}_product_catalog`,
  asc: `burrell_${environment}_product_catalog_replica_title_asc`,
  desc: `burrell_${environment}_product_catalog_replica_title_desc`,
  recentlyAdded: `burrell_${environment}_product_catalog_replica_recently_added`,
  mostPopular: `burrell_${environment}_product_catalog_replica_most_popular`,
  priceHighLow: `burrell_${environment}_product_catalog_replica_price_high_low`,
  priceLowHigh: `burrell_${environment}_product_catalog_replica_price_low_high`
};
